// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Pp-z","breadcrumbForward":"Qp-z","breadcrumbBack":"Rp-z","selected":"Sp-z"};